import React, {useMemo} from "react"
import styles from "./HTMLPreviewEditor.module.css"
import {buildEmailPreviewDocument, EMAIL_PREVIEW_SANDBOX} from "./emailPreviewDocument"

const PreviewPane: React.FC<{
    markdown: string
    isFullScreen?: boolean
    /** `inline` is the chat-thread size: a fixed-height, user-resizable frame that scrolls internally. */
    variant?: "iframe" | "inline"
}> = ({markdown, isFullScreen = false, variant = "iframe"}) => {
    const srcDoc = useMemo(() => buildEmailPreviewDocument(markdown ?? ""), [markdown])

    if (variant === "inline") {
        return (
            <div className={styles.inlinePreview}>
                <iframe
                    title="Email preview"
                    sandbox={EMAIL_PREVIEW_SANDBOX}
                    srcDoc={srcDoc}
                    className={styles.inlinePreviewFrame}
                />
            </div>
        )
    }

    return (
        <iframe
            title="Preview"
            sandbox={EMAIL_PREVIEW_SANDBOX}
            srcDoc={srcDoc}
            width="100%"
            height="100%"
            className={isFullScreen ? styles.IFrameFullscreenStyles : styles.IFrameDefaultStyles}
        />
    )
}

export default PreviewPane
